'use client';

import { Skeleton } from '@/components/ui/skeleton';

export function ThreadsSidebarSkeleton() {
  return (
    <div
      data-thread-sidebar-surface="skeleton"
      className="flex h-full flex-col gap-3 p-3"
    >
      <Skeleton className="h-8 w-8 rounded-full" />
      {Array.from({ length: 6 }).map((_, index) => (
        <Skeleton key={index} className="h-8 w-full" />
      ))}
    </div>
  );
}
